import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import { Picture } from "@/components/wpl/image/src/index.ts";
import { wacToken } from "@/libraries/design/foundations/index.ts";

import { getDataUrl } from "./svgs.tsx";
import * as svgs from "./svgs.tsx";

export interface PriceSlashProps {
    color: "purple" | "yellow";
}
export const PriceSlash = ({ color }: PriceSlashProps) => {
    return (
        <svg
            width="120%"
            height="36"
            viewBox="0 0 72 36"
            preserveAspectRatio="none"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                position: "absolute",
                top: "25%",
                left: "-10px"
            }}
        >
            <path
                d="M67.6912 11.8154C72.5987 7.07718 82.5811 5.78675 90.8376 3.53893C103.285 -6.23966 55.5829 11.0014 48.6155 14.3702C58.3372 13.7205 49.1305 17.0531 44.9656 17.2605C53.1639 11.0398 24.5485 21.4946 32.0375 21.9193C31.1321 22.3728 27.5597 24.3298 29.3008 22.1954C26.2654 22.3338 -4.37219 34.2365 1.1448 35.0404C23.0541 27.7765 41.1913 18.9707 67.6912 11.8154Z"
                fill={color === "purple" ? "#BF63F3" : "#FFA900"}
            />
        </svg>
    );
};

const freeTagStandardContainer = css({
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "33px"
});

const freeTagStandardBackground = css({
    width: "110%",
    height: "110%",
    zIndex: -1,
    // eslint-disable-next-line local/ensure-wac-token-usage,
    backgroundColor: "#FFE48F",
    transform: "rotate(2.01deg)",
    transformOrigin: "0 0"
});

const freeTagStandardMessage = css({
    fontFamily: wacToken("font.charlie.text"),
    fontWeight: 700,
    padding: `${token("space.100")} ${token("space.150")}`,
    fontSize: "14px",
    textWrap: "auto",
    transform: "rotate(-2.01deg)",
    position: "relative"
});

export const FreeTag14Days = () => {
    const intl = useIntl();
    const freeTag14DaysMessage = intl.formatMessage({
        id: "Pricing.PriceCard.freeFor14Days",
        defaultMessage: "Free for 14 days!"
    });
    return (
        <div css={freeTagStandardContainer}>
            <div css={freeTagStandardBackground}>
                <div css={freeTagStandardMessage}>{freeTag14DaysMessage}</div>
            </div>
        </div>
    );
};

const freeTagPremiumContainer = css({
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "33px"
    // overflow: "visible"
});

const freeTagPremiumBackground = css({
    position: "relative",
    height: "110%",
    zIndex: -1,
    // eslint-disable-next-line local/ensure-wac-token-usage,
    backgroundColor: "#BF63F3",
    transform: "rotate(-2.34deg)",
    transformOrigin: "0 0"
});

const freeTagPremiumMessage = css({
    fontFamily: wacToken("font.charlie.text"),
    fontWeight: 700,
    padding: `${token("space.100")} ${token("space.150")}`,
    fontSize: "14px",
    textWrap: "auto",
    transform: "rotate(2.34deg)",
    color: wacToken("color.neutral.light0"),
    position: "relative"
});

const EyelashContainer = css({
    position: "absolute",
    insetBlockStart: "-27px",
    insetInlineEnd: "-23px"
    // zIndex: 1
});

export const Eyelash = () => {
    return (
        <div
            role="presentation"
            dangerouslySetInnerHTML={{ __html: svgs.eyelash }}
        />
    );
};

export const FreeTag30Days = () => {
    const intl = useIntl();
    const freeTag30DaysMessage = intl.formatMessage({
        id: "Pricing.PriceCard.freeFor30Days",
        defaultMessage: "Free for 30 days!"
    });

    return (
        <div css={freeTagPremiumContainer}>
            <div css={freeTagPremiumBackground}>
                <div css={freeTagPremiumMessage}>{freeTag30DaysMessage}</div>
            </div>
            <div css={EyelashContainer}>
                <Eyelash />
            </div>
        </div>
    );
};

export const RecommendationBanner = () => {
    const intl = useIntl();
    const recommendedText = intl.formatMessage({
        id: "Pricing.PriceCard.recommended",
        defaultMessage: "Recommended"
    });

    return (
        <div
            css={css({
                color: wacToken("color.neutral.light0"),
                position: "relative",
                textTransform: "uppercase",
                fontWeight: 700,
                fontSize: "12px",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                display: "flex"
            })}
        >
            <Picture
                css={css({
                    position: "absolute",
                    insetBlockStart: 0,
                    zIndex: -1,
                    objectFit: "cover"
                })}
                image={{
                    src: getDataUrl(svgs.recommendedRibbon),
                    alt: ""
                }}
            />
            <div css={css({ textAlign: "center" })}>{recommendedText}</div>
        </div>
    );
};
